import React, { useEffect, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { MiniLoader } from '@pwc/pwc-deals-ui';
import './ContentItem.scss';
import { useSelector } from 'react-redux';
import UnableToLoadContent from 'features/analyses/common/UnableToLoadContent/UnableToLoadContent';
import { cleanUpHTML } from 'common/helpers/excelHiddenColumnsRemover';
import {
  junctionColorMapping,
  junctionSmartSymbolsMapping,
} from 'common/helpers/junctionColorMapping';
import { sanitize } from 'common/services/sanitizeService';

const ContentItemNew = ({
  projectId,
  libraryItem,
  libraryItemId,
  contentId,
  content,
  panel,
  children = (
    <UnableToLoadContent
      projectId={projectId}
      placeId="content-error-default-contentItem"
    />
  ),
}) => {
  const [htmlData, setHtmlData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [svgWidth, setSvgWidth] = useState(null);
  const [hasError, setHasError] = useState(false);
  const darkMode = useSelector((state) => state.userSettings.settings.darkMode);

  useEffect(() => {
    const getWidthFromSvg = (data) => {
      if (data.includes('svg')) {
        const xmlDoc = new DOMParser().parseFromString(data, 'application/xml');
        const svg = xmlDoc.getElementsByTagName('svg')[0];
        if (svg) {
          const viewBox = svg.getAttribute('viewbox');
          if (viewBox) {
            return viewBox.split(' ')[2];
          }
        }
      }
      return null;
    };

    if (content) {
      const mappedHtml = junctionSmartSymbolsMapping(
        junctionColorMapping(content, darkMode, libraryItem)
      );
      setHtmlData(cleanUpHTML(mappedHtml));
      setSvgWidth(getWidthFromSvg(mappedHtml));
      setIsLoading(false);
      setHasError(false);
    } else {
      setHasError(true);
      setIsLoading(false);
    }
  }, [projectId, libraryItemId, libraryItem, contentId, content, darkMode]);

  const getItemToSanitize = () => {
    if (hasError) {
      if (panel?.errorCode || panel?.error?.apiErrorCode) {
        return renderToStaticMarkup(
          <UnableToLoadContent
            projectId={projectId}
            errorCode={panel?.errorCode || panel?.error?.apiErrorCode}
            type={panel?.statusType}
            data={{
              sharePointItemUrl: libraryItem?.sharePointItemUrl,
              worksheetName:
                libraryItem?.autoSync &&
                libraryItem?.autoSync.data.worksheetName,
              chartName:
                libraryItem?.autoSync && libraryItem?.autoSync.data.chartName,
              groupName:
                libraryItem?.autoSync && libraryItem?.autoSync.data.groupName,
              slideNumber: libraryItem?.slideNumber,
              name: libraryItem?.autoSync && libraryItem?.autoSync.data.name,
            }}
            placeId="content-error-default-contentItem"
          />
        );
      }
      return renderToStaticMarkup(children);
    }
    return htmlData;
  };

  return (
    <>
      {isLoading && <MiniLoader dataTestId="excel-content-loader" />}
      {!isLoading && (
        <>
          <div
            data-testid="excel-content-item"
            className="content-item-container content-item-container-scroll css-override"
            dangerouslySetInnerHTML={{
              __html: sanitize(getItemToSanitize()),
            }}
          />
        </>
      )}
    </>
  );
};

export default ContentItemNew;
